import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faInstagram,faTiktok, faFacebook } from '@fortawesome/free-brands-svg-icons';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService, Language } from '../../services/language.service';
import { CommonModule } from '@angular/common';

import { LanguageSelectorComponent } from '../language-selector/language-selector.component';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterModule, FontAwesomeModule, TranslateModule, CommonModule, LanguageSelectorComponent],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  currentYear: number = new Date().getFullYear();
  faInstagram = faInstagram;
  faTiktok = faTiktok;
  faFacebook = faFacebook;

  constructor(public languageService: LanguageService) {}

  setLanguage(lang: Language) {
    this.languageService.use(lang);
  }
}
